$(document).ready(function () {
  // $(".main_ugc-product-block").click(function () {
  //   var currentId = $(this).attr("data-id");
  //   var currentQty = 1;
  //   var items = [];

  //   items.push({ id: currentId, quantity: currentQty });
  //   jQuery.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: {
  //       items: items,
  //     },
  //     dataType: "json",
  //     success: function () {},
  //     error: function () {},
  //   });
  // });

  $(document).on("click", ".ts-header__menu-toggle", function () {
    if ($(this).hasClass("is-open")) {
    } else {
      var headerIsOnTop = false;
      var headerisInTheMiddle = false;
      if ($(".ts-header").hasClass("sticky")) {
        headerisInTheMiddle = true;
      } else {
        headerIsOnTop = true;
      }

      console.log(headerIsOnTop, headerisInTheMiddle);
      if (headerIsOnTop) {
        $(".ts-header__menu .drawer__content").css("top", "120px");
        $(".ts-header__menu .drawer__content").css(
          "height",
          "calc(100% - 120px)"
        );
      }
      if (headerisInTheMiddle) {
        $(".ts-header__menu .drawer__content").css("top", "70px");
        $(".ts-header__menu .drawer__content").css(
          "height",
          "calc(100% - 70px)"
        );
      }
    }
  });

  $(document).on("click", ".ts_header-mobile-menu-item", function (evt) {
    var currentHref = $(this).attr("href");
    if (currentHref == "#notifications") {
      evt.preventDefault();
      $(".ts-header__fav-toggle").trigger("click");
      $(".ts-header__control.ts-header__control--close").trigger("click");
    }
  });
});
